<template>
  <div>
    <a-row>
      <g-master name="forms_components"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                :parentData="fhParentData"
                @action="masterAction"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Etiqueta')" :has-feedback="false">
                <a-input
                  v-decorator="['label', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Nombre')">
                <a-input
                  v-decorator="['name', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Orden')" v-bind="fiOptions">
                <a-input-number
                  v-decorator="['orden', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                  style="width: 100%">
                </a-input-number>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Tipo de componente')" :has-feedback="false"
                          :formItemConfig="fiOptions"
                          :selectedObj.sync="tipoComponenteSeleccionado"
                          :decorator="['id_h_component_type', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                          :params="tipo_componente"
                          ref="tipoComponente"
              >
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Requerido')" :has-feedback="false">
                <a-checkbox
                  v-decorator="['required', {valuePropName: 'checked',  rules: [{ required: true, message: 'Valor requerido'}]}]">
                </a-checkbox>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Estado')" :has-feedback="false">
                <a-checkbox
                  v-decorator="['status', {valuePropName: 'checked',  rules: [{ required: true, message: 'Valor requerido'}]}]">
                </a-checkbox>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-show="requiredSubquery" v-bind="fiOptions" :label="$t('Subconsulta')"
                           :has-feedback="false">
                <a-textarea
                  v-decorator="['component_sql', { rules: [{ required: requiredSubquery, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>


          </a-row>
        </template>
      </g-master>
    </a-row>
    <a-row>
      <a-tabs defaultActiveKey="2">
        <a-tab-pane tab="OPCIONES" key="2">
          <forms-comp-options v-if="idseleccionado" :id="idseleccionado"></forms-comp-options>
          <span v-else>Seleccione un componente para ver más.</span>
        </a-tab-pane>
      </a-tabs>
    </a-row>
  </div>
</template>
<script>
  export default {
    props: ['id_header'],
    data () {
      return {
        tipoComponenteSeleccionado: {},
        requiredSubquery: false,
        tipo_componente: {
          h_lookup_type: 'FORMS_COMPONENT_TYPE'
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'forms_components',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Nombre', dataIndex: 'name', sorter: true},
              {title: 'Estado', dataIndex: 'status_desc', sorter: true},
              {title: 'Orden', dataIndex: 'orden', sorter: true},
              {title: 'Tipo componente', dataIndex: 'h_component_type', sorter: true},
              {title: 'Subconsulta', dataIndex: 'component_sql', sorter: true},
              {title: 'Requerido', dataIndex: 'required_desc', sorter: true},
              {title: 'Etiqueta', dataIndex: 'label', sorter: true}
            ],
            allowSelect: true,
            selectedRows: []
          },
          modalFieldsSetup: [
            {name: 'name'},
            {name: 'status', type: 'boolean'},
            {name: 'orden'},
            {name: 'id_h_component_type'},
            {name: 'component_sql'},
            {name: 'required'},
            {name: 'label'}
          ]
        }
      }
    },
    methods: {
      masterAction (action) {
        if (action.action === 'masterEdit') {
          this.$refs.tipoComponente && this.$refs.tipoComponente.handleChange(action.record.id_h_component_type)
        }
      }
    },
    computed: {
      idseleccionado () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      },
      fhParentData () {
        return {
          id_header: this.id_header
        }
      }
    },
    watch: {
      tipoComponenteSeleccionado () {
        this.requiredSubquery = this.tipoComponenteSeleccionado.text === 'LOV_SQL' ||
          this.tipoComponenteSeleccionado.text === 'LOV_SQL_LIKE'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Form/FormsComponents.vue